import apiClient from "./base.service";

export default {
    async index() {
        return await apiClient.get(`/webhook`);
    },
    async get(id) {
        return await apiClient.get(`/webhook/${id}`);
    },
    async update(id, data) {
        return await apiClient.put(`/webhook/${id}`, data);
    },
    async create(data) {
        return await apiClient.post(`/webhook`, data);
    },
    async remove(id) {
        return await apiClient.delete(`/webhook/${id}`);
    }
}